import { motion } from "framer-motion";
import { Handshake, Phone } from "lucide-react";
import { AnimatedCounter } from "./AnimatedCounter";

export const DealerNetwork = ({ content, onRegister }) => {
  const section = content.dealerSection;
  const primaryPhone = content.contact.phones?.[0]?.tel || "";
  return (
    <section id="dealer" data-testid="dealer-section" className="relative py-24 lg:py-32 bg-surface-deep overflow-hidden">
      <div className="absolute inset-0 bg-[linear-gradient(120deg,rgba(0,175,76,0.12),transparent_36%,rgba(0,229,255,0.05)_78%,transparent)]" aria-hidden="true" />
      <div className="relative max-w-7xl mx-auto px-5 md:px-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="section-kicker mb-4">{section.kicker}</span>
            <h2 className="font-display font-bold text-4xl sm:text-5xl">
              {section.title}
            </h2>
            <p className="mt-5 text-white/65 leading-relaxed max-w-xl">
              {section.description}
            </p>

            <div className="mt-8 flex flex-wrap gap-3">
              <button
                onClick={() => onRegister(null, "Dealer / Distributor", "Dealership Enquiry")}
                data-testid="apply-dealership-cta"
                className="btn-glow inline-flex items-center gap-2 bg-brand text-black font-semibold px-7 py-3.5 rounded-full"
              >
                <Handshake size={18} /> {content.actions.applyDealership}
              </button>
              <a
                href={`tel:${primaryPhone}`}
                data-testid="talk-to-sales-cta"
                className="inline-flex items-center gap-2 border border-white/20 hover:border-brand/60 text-white px-7 py-3.5 rounded-full transition-colors"
              >
                <Phone size={18} /> {content.actions.talkToSales}
              </a>
            </div>
          </motion.div>

          <div className="grid gap-5">
            {section.stats.map((s, i) => (
              <motion.div
                key={s.label}
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                data-testid={`dealer-stat-${i}`}
                className="glass rounded-lg p-7 flex items-center justify-between"
              >
                <span className="text-white/70 max-w-[60%]">{s.label}</span>
                <span className="font-display font-bold text-3xl sm:text-4xl text-brand glow-text">
                  <AnimatedCounter value={s.value} suffix={s.suffix} display={s.display} />
                </span>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default DealerNetwork;
